export default class Contact{
    id;
    portfolioId;
    contactId;
    permissions;

    constructor(id, portfolioId, contactId, permissions){    
        this.id = id;
        this.portfolioId = portfolioId;
        this.contactId = contactId;
        this.permissions = permissions ?? 1;
    } 
}